import { createAction, props } from '@ngrx/store';
import { ToastModel } from '../../domain/models/toast.model';

export const toastShow = createAction(
  '[Toast] Exibir',
  props<{ toastModel: ToastModel }>()
);
